module.exports = __webpack_public_path__ + "img/reserved.8e497d4d.jpg";